import { defineComponent } from "vue";
import "./styles/Nft.scss";

export default defineComponent({
  setup() {
    return () => <div class="nft-wrapper">
      <basic-title content={ "NFT MYSTERY BOX" } />
      <div class="space-15px"></div>
      <banner src="/images/NftBanner/NftBanner.png" srcset="/images/NftBanner/NftBanner@2x.png 2x,/images/NftBanner/NftBanner@3x.png 3x" />
      <div class="space-15px"></div>
      <description content={ "Both R&D bases and spacecraft have 3 levels and 5 stars.Different grades and stars correspond to different yields." } />
      <div class="space-20px"></div>
      <star-line />
    </div>
  }
});
